const createIframe = () => {
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  return iframe;
};

export const clientDataSticker = (data) => {
  const iframe = createIframe();

  iframe.contentDocument.write(`
    <html lang="no">
      <head>
        <title>Kundeetikett</title>
        <style>
          @page {
            size: 6in 4in;
            margin: 0;
          }

          * {
            box-sizing: border-box;
          }

          body {
            margin: 0;
            padding: 0;
            width: 6in;
            height: 4in;
            background-color: #ffffff;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            overflow: hidden;
          }

          .parent-container {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 16px;
            background: #ffffff;
            page-break-inside: avoid;
          }

          .printable-content {
            width: 100%;
            max-height: 100%;
            background: white;
            padding: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            page-break-inside: avoid;
          }

          .sticker-header {
            background: #000000;
            color: white;
            padding: 8px 12px;
            margin-bottom: 12px;
            text-align: center;
            border-radius: 6px;
            width: 100%;
          }

          .sticker-title {
            margin: 0;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 1.2px;
            text-transform: uppercase;
          }

          .order-number {
            margin: 0 0 12px 0;
            font-size: 42px;
            font-weight: 700;
            text-align: center;
            color: #000000;
            letter-spacing: 2px;
            line-height: 1;
          }

          .customer-info {
            background: #f8f8f8;
            border: 2px solid #555555;
            border-radius: 6px;
            padding: 10px 16px;
            margin-bottom: 12px;
            text-align: center;
            min-width: 280px;
          }

          .customer-name {
            margin: 0 0 6px 0;
            font-size: 18px;
            font-weight: 600;
            color: #000000;
            line-height: 1.2;
          }

          .customer-city {
            margin: 0;
            font-size: 20px;
            font-weight: 700;
            color: #000000;
            text-transform: uppercase;
            letter-spacing: 0.8px;
            line-height: 1.2;
          }

          .week-info {
            background: #000000;
            color: white;
            padding: 8px 20px;
            border-radius: 6px;
            margin-bottom: 12px;
            text-align: center;
          }

          .week-label {
            margin: 0;
            font-size: 11px;
            font-weight: 400;
            opacity: 0.9;
            text-transform: uppercase;
            letter-spacing: 0.8px;
            line-height: 1;
          }

          .week-number {
            margin: 3px 0 0 0;
            font-size: 24px;
            font-weight: 700;
            letter-spacing: 1.5px;
            line-height: 1;
          }

          .box-info {
            background: #f8f8f8;
            border: 1px solid #555555;
            border-radius: 6px;
            padding: 8px 16px;
            text-align: center;
            font-size: 13px;
            font-weight: 600;
            color: #000000;
            max-width: 85%;
            word-wrap: break-word;
            line-height: 1.3;
            overflow-wrap: break-word;
            hyphens: auto;
          }

          .empty-info {
            display: none;
          }
        </style>
      </head>
      <body>
        <div class="parent-container">
          <div class="printable-content">
            <div class="sticker-header">
              <h1 class="sticker-title">BD Bildeler - Kundeetikett</h1>
            </div>

            <div class="order-number">
              ${data.scanned.order.replace(/[<>"']/g, '')}
            </div>

            ${data.printData.name || data.printData.city ? `
              <div class="customer-info">
                ${data.printData.name ? `<p class="customer-name">${data.printData.name}</p>` : ''}
                ${data.printData.city ? `<p class="customer-city">${data.printData.city.toUpperCase()}</p>` : ''}
              </div>
            ` : ''}

            ${data.printData.week ? `
              <div class="week-info">
                <p class="week-label">Uke</p>
                <p class="week-number">${data.printData.week}</p>
              </div>
            ` : ''}

            ${data.printData?.box ? `
              <div class="box-info">
                📦 ${data.printData.box}
              </div>
            ` : ''}
          </div>
        </div>
      </body>
    </html>
  `);
  iframe.contentDocument.close();

  return iframe;
};

export const packageSticker = (data) => {
  const iframe = createIframe();

  iframe.contentDocument.write(`
    <html lang="en">
      <head>
        <title>Package Sticker</title>
        <style>
          @page {
            size: 4in 6in;
            margin: 0;
          }

          * {
            box-sizing: border-box;
          }

          body {
            margin: 0;
            padding: 0;
            background-color: #ffffff;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            overflow: hidden;
          }

          .parent-container {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            width: 100%;
            height: 100%;
            padding: 16px;
            background: #ffffff;
          }

          .printable-content {
            width: 100%;
            background: white;
            padding: 0;
          }

          .sticker-header {
            background: #000000;
            color: white;
            padding: 10px 12px;
            margin-bottom: 16px;
            text-align: center;
            border-radius: 6px;
          }

          .sticker-title {
            margin: 0;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 1px;
            text-transform: uppercase;
          }

          .sticker-subtitle {
            margin: 2px 0 0 0;
            font-size: 9px;
            opacity: 0.9;
            font-weight: 400;
          }

          .qr-section {
            background: #ffffff;
            padding: 8px;
            margin-bottom: 16px;
            text-align: center;
          }

          .qr-code-wrapper {
            background: white;
            padding: 0;
            display: inline-block;
            border: 3px solid #000000;
            border-radius: 6px;
            overflow: hidden;
          }

          #qr-code {
            display: block;
            width: 140px;
            height: 140px;
          }

          .box-name-section {
            background: #000000;
            color: white;
            padding: 10px 12px;
            margin-bottom: 16px;
            border-radius: 6px;
          }

          #packing-box-name {
            margin: 0;
            font-size: 14px;
            font-weight: 700;
            word-break: break-word;
            letter-spacing: 0.5px;
            text-align: center;
          }

          .table-section {
            margin-top: 0;
            border: 1px solid #555555;
            border-radius: 8px;
            overflow: hidden;
          }

          .table-header-label {
            background: #000000;
            color: white;
            padding: 8px;
            font-size: 11px;
            font-weight: 600;
            text-align: center;
            letter-spacing: 0.5px;
            margin: 0;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 8px;
            background: white;
            margin: 0;
          }

          thead {
            background: #f8f8f8;
            border-top: 1px solid #555555;
            border-bottom: 1px solid #555555;
          }

          th {
            padding: 7px 5px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.3px;
            font-size: 9px;
            color: #333333;
          }

          th:nth-child(1) {
            text-align: left;
          }

          th:nth-child(2),
          th:nth-child(3) {
            text-align: center;
          }

          th:nth-child(4) {
            text-align: right;
          }

          td {
            padding: 6px 5px;
            vertical-align: middle;
          }

          tbody tr {
            border-bottom: 1px solid #e0e0e0;
          }

          tbody tr:last-child {
            border-bottom: none;
          }

          tbody tr:nth-child(even) {
            background-color: #fafafa;
          }

          tbody tr:nth-child(odd) {
            background-color: #ffffff;
          }

          .name-cell {
            text-align: left;
            font-weight: 600;
            color: #000000;
          }

          .plate-cell {
            text-align: center;
            font-weight: 700;
            color: #000000;
            font-family: 'Courier New', monospace;
          }

          .count-cell {
            text-align: center;
            font-weight: 700;
            color: #000000;
          }

          .price-cell {
            text-align: right;
            font-weight: 700;
            color: #000000;
            font-family: 'Courier New', monospace;
          }

          .local-badge {
            display: inline-block;
            background: #000000;
            color: white;
            padding: 1px 4px;
            border-radius: 3px;
            font-size: 7px;
            font-weight: 700;
            margin-left: 3px;
            vertical-align: middle;
          }

          .sticker-footer {
            margin-top: 12px;
            padding-top: 8px;
            text-align: center;
            font-size: 7px;
            color: #666666;
            font-style: italic;
          }
        </style>
      </head>
      <body>
        <div class="parent-container">
          <div class="printable-content">
            <div class="sticker-header">
              <h1 class="sticker-title">BD Bildeler</h1>
              <p class="sticker-subtitle">Lager og forsendelsesidentifikasjon</p>
            </div>

            <div class="qr-section">
              <div class="qr-code-wrapper">
                <img id="qr-code" src="data:image/png;base64,${data.code}" alt="Pakke QR-kode">
              </div>
            </div>

            ${data?.box ? `
              <div class="box-name-section">
                <div id="packing-box-name">📦 ${data.box}</div>
              </div>
            ` : ''}

            <div class="table-section">
              <div class="table-header-label">📋 Pakkeinnhold</div>
              <table>
                <thead>
                  <tr>
                    <th style="width: 45%;">Produktnavn</th>
                    <th style="width: 20%;">Skilt</th>
                    <th style="width: 12%;">Ant.</th>
                    <th style="width: 23%;">Beløp</th>
                  </tr>
                </thead>
                <tbody id="tableBody">
                  <!-- Tabellinnhold genereres dynamisk -->
                </tbody>
              </table>
            </div>

            <div class="sticker-footer">
              Skann QR-kode for pakkedetaljer • Håndter forsiktig
            </div>
          </div>
        </div>
      </body>
      <script>
        function populateTable(products) {
          const tableBody = document.getElementById("tableBody");
          tableBody.innerHTML = "";

          products.forEach((item) => {
            const row = tableBody.insertRow();

            const nameCell = row.insertCell(0);
            nameCell.className = 'name-cell';

            const plate = row.insertCell(1);
            plate.className = 'plate-cell';

            const count = row.insertCell(2);
            count.className = 'count-cell';

            const price = row.insertCell(3);
            price.className = 'price-cell';

            let nameColumn = item.noteType === 3
              ? item.name + " (" + item.notes.replace(/<[^>]*>|&nbsp;/g, '') + ")"
              : item.name;

            if (item?.replacedWithLocal) {
              nameColumn += '<span class="local-badge">LOCAL</span>';
            }

            nameCell.innerHTML = nameColumn;

            const match = item.metaData.match(/\\b[A-Za-z]{2}[0-9]{5}\\b/);
            plate.textContent = match ? match[0].toUpperCase() : '—';

            count.textContent = item.count;
            price.textContent = (item.count * item.webPrice).toLocaleString('en') + ' kr';
          });
        }

        populateTable(${JSON.stringify(data.products)});
      </script>
    </html>
  `);
  iframe.contentDocument.close();

  return iframe;
};
